import { configureStore } from "@reduxjs/toolkit";
import WebsiteGlobalData from '../ReduxSlices/getGlobalDataSlice';
import WebsitePageData from '../ReduxSlices/getPageDataSlice';

export const store = configureStore({
    reducer: {
        globaldata: WebsiteGlobalData,
        pagedata: WebsitePageData
    },
});